import { useEffect, useState } from 'react'

import { getLoggedInUserIdentityWithCache } from '../api/identity'
import { User } from '../models/user'

export function useHasFeatureFlag(flag: string) {
  const [user, setUser] = useState<(User & { feature_flags: User['featureFlags'] }) | null>(null)

  useEffect(() => {
    async function fetchUser() {
      const { user } = await getLoggedInUserIdentityWithCache()
      setUser(user)
    }

    fetchUser()
  }, [])

  return Boolean(user?.feature_flags?.[flag])
}

export function useHasEnabledFeasibilityCheckForVCUsers() {
  return useHasFeatureFlag('run-feasibility-check-on-vc-users')
}

export function useHasCarrierSelectionOnboarding() {
  return useHasFeatureFlag('public-carrier-selection-onboarding')
}

export function useHasSyncTruckToMotive() {
  return useHasFeatureFlag('vc-console-to-kt-vehicle-sync')
}

export function useHasCustomLoadsInstantBook() {
  return useHasFeatureFlag('custom-loads-instant-book')
}

export function useHasBrokerCarrierRelationship() {
  return useHasFeatureFlag('public-broker-carrier-relationship')
}

export function useHasSendbirdChat() {
  return useHasFeatureFlag('public-console-in-app-chat')
}

export function useHasAllowLoadRecoveryAutomatedTransitions() {
  return useHasFeatureFlag('allow-load-recovery-automated-transitions')
}

export function useHasEnhancedSafetyTool() {
  return useHasFeatureFlag('public-enhanced-safety-tool')
}

export function useHasJobListRedesign() {
  return useHasFeatureFlag('public-job-list-redesign')
}

export function useHasEquipmentManagement() {
  return useHasFeatureFlag('public-equipment-management')
}

export function useHasPerformanceScores() {
  return useHasFeatureFlag('public-performance-scores')
}

export function useHasTrailerInvoiceParsing() {
  return useHasFeatureFlag('trailer-invoice-parsing')
}

export function useHasConsoleJobDetailsRedesign() {
  return useHasFeatureFlag('public-console-job-details-redesign')
}
